export type DataLayerEvent = {
  event: string;
  [key: string]: unknown;
}

export type newDataLayerEvent = {
  event: 'ga_event';
  eventCategory: 'lk' | 'error';
  eventAction: 'click' | 'open' | 'close' | 'confirm' | 'focus' | 'error';
  eventCategory1?: string;
  eventLabel?: string;
  eventLabel1?: string | boolean;
  eventLabel2?: string;
  eventLabel3?: string;
  value?: string;
  value1?: string;
  value2?: string;
  value3?: string | boolean;
  value4?: string | boolean;
  value5?: string | number;
  value6?: string;
}

export function pushDataLayer({ event, ...attrs }: DataLayerEvent): void {
  if (window.dataLayer) {
    window.dataLayer.push({ event, ...attrs });
  }
}
